import axios from '../config/axiosConfig';
import { BASE_URL } from './constant/BaseApiUrl';

export default class QuoteAssignService {
  changeStatus(payload) {
    return axios.post(`${BASE_URL}quotes/assign/process`, payload);
  }

  generatePdf(id, isSent) {
    return axios.get(`${BASE_URL}quotes/${id}/generate-pdf?is-sent=${isSent}`);
  }

  assignService(payload, id) {
    return axios.put(`${BASE_URL}quotes/${id}/assigns`, payload);
  }
}
